import { useEffect } from 'react';

import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import { captureException } from '@/services/sentry';

const UnhandledStep = ({ request }: { request: RequestWithRelations }) => {
  useEffect(() => {
    captureException(
      new Error(
        `Unhandled step for request ${request.id}: ${request.articles
          ?.map((article) => `${article.id} - ${article.step?.step}`)
          .join(', ')}`
      )
    );
  }, []);

  return (
    <BrandRequestMainContent>
      <ClientArticlesList request={request} showPrice={!!request.client} showArticleComment />
    </BrandRequestMainContent>
  );
};

export default UnhandledStep;
